import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import { SysField } from 'injury-mgmt/models/OhsInjuryMgmtRecord';

import { OhsFormSettings } from '../services/OhsFormModels';
import { fetchBulkSysFieldCusvalFormat } from './OhsSystemFieldServices';
import { OhsCusval } from '../cusvals/OhsCusvalModel';
import { formatSysFieldToCusvalType } from './sysFieldUtils';
import OhsFixedCategoryCusvalFieldsSectionContent from '../cusvals/OhsFixedCategoryCusvalFieldsSectionContent';

interface Props {
  id: string;
  ohsFormSettings: OhsFormSettings;
  cusvalConfig: OhsCusval[];
  sysFieldConfig: SysField[];
  layout: string[];
  gridOptions?: any;
  templateId?: string;
  recordId?: string;
  taskId?: string;
}

function OhsSysFieldCusvalGroup(props: Props) {
  const [mergedConfig, setMergedConfig] = useState<OhsCusval[]>([]);
  const [isFetched, setIsFetched] = useState(false);

  const buildSysField = async (): Promise<OhsCusval[]> => {
    const sysFieldIds = (props.sysFieldConfig || []).map((item) => item?._id);
    if (sysFieldIds.length < 1) return [];

    // get sys field cusval definitions
    const sysFieldConfigDefs = await fetchBulkSysFieldCusvalFormat(sysFieldIds);

    // merge def config and record config, record config values are top priority on duplicate props
    return (props.sysFieldConfig || []).map((recordSysField) => {
      const target = sysFieldConfigDefs.find((configDef) => configDef?._id === recordSysField?._id);
      return {
        title: recordSysField.name,
        description: target?.description,
        _id: recordSysField._id,
        type: formatSysFieldToCusvalType(recordSysField.fieldType),
        options: target?.options,
        required:
          (!_.isUndefined(recordSysField.required) ? recordSysField.required : target?.required) ||
          false,
        moduleType: target?.moduleType,
      };
    });
  };

  const buildConfig = async () => {
    if (props.layout.length === 0) {
      setMergedConfig([]);
      return;
    }
    const sysFieldValues = await buildSysField();
    // merge cusval and sysField
    const unorderedConfig = [...props.cusvalConfig, ...sysFieldValues];
    // set to object before arranging
    const configObject = Object.fromEntries(unorderedConfig.map((item) => [item._id, item]));
    // arrange based on layout
    const sorted = props.layout.map((id) => configObject[id]).filter(Boolean);

    setMergedConfig(sorted);
    setIsFetched(true);
  };

  useEffect(() => {
    buildConfig();
  }, [props.layout, props.cusvalConfig, props.sysFieldConfig]);

  if (!isFetched) return '';

  return (
    <OhsFixedCategoryCusvalFieldsSectionContent
      id={props.id}
      ohsFormSettings={props.ohsFormSettings}
      gridOptions={props.gridOptions}
      cusvalsConfig={mergedConfig}
      isInitCusvalConfigFetched={isFetched}
      templateId={props.templateId}
      recordId={props.recordId}
      taskId={props.taskId}
      maxCount={1}
    />
  );
}

OhsSysFieldCusvalGroup.defaultProps = {
  gridOptions: {},
  templateId: undefined,
  recordId: undefined,
  taskId: undefined,
};

export default OhsSysFieldCusvalGroup;
